import _classCallCheck from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export var ClassList = /*#__PURE__*/function () {
  function ClassList() {
    _classCallCheck(this, ClassList);
    _defineProperty(this, "classNames", []);
    for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
      classNames[_key] = arguments[_key];
    }
    this.classNames = this.filter(classNames);
  }
  return _createClass(ClassList, [{
    key: "filter",
    value: function filter(array) {
      return array.filter(function (item) {
        return Boolean(item);
      });
    }
  }, {
    key: "add",
    value: function add() {
      for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classNames[_key2] = arguments[_key2];
      }
      this.classNames = this.classNames.concat(this.filter(classNames));
    }
  }, {
    key: "remove",
    value: function remove() {
      for (var _len3 = arguments.length, classNames = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        classNames[_key3] = arguments[_key3];
      }
      this.classNames = this.classNames.filter(function (item) {
        return classNames.indexOf(item) === -1;
      });
    }
  }, {
    key: "item",
    value: function item(index) {
      return this.classNames[index];
    }
  }, {
    key: "toggle",
    value: function toggle(item, force) {
      if (force !== undefined) {
        force ? this.add(item) : this.remove(item);
        return;
      }
      this.contains(item) ? this.remove(item) : this.add(item);
    }
  }, {
    key: "contains",
    value: function contains(item) {
      return this.classNames.indexOf(item) !== -1;
    }
  }, {
    key: "replace",
    value: function replace(oldClass, newClass) {
      this.remove(oldClass);
      this.add(newClass);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.classNames.join(' ');
    }
  }]);
}();